<script setup>
/**
 * AppConfirm — Hôte global de la modale de confirmation pilotée par
 * `useConfirmModal().ask()`. À monter une seule fois dans App.vue.
 */
import { computed } from 'vue'
import ConfirmModal from '@/components/ui/ConfirmModal.vue'
import { useConfirmModal } from '@/composables/useConfirmModal'

const { state, confirm, cancel } = useConfirmModal()

// Toute fermeture hors bouton « Confirmer » (Échap, masque, Annuler) vaut annulation.
const visible = computed({
  get: () => state.open,
  set: (v) => { if (!v) cancel() },
})
</script>

<template>
  <ConfirmModal
    v-model:visible="visible"
    :title="state.title"
    :message="state.message"
    :confirm-label="state.confirmLabel"
    :cancel-label="state.cancelLabel"
    :severity="state.severity"
    :icon="state.icon"
    @confirm="confirm"
  />
</template>
